import { createSlice } from "@reduxjs/toolkit";
import {
  JobPricingPayloads,
  JobPricingSearchState
} from "../../helpers/models/JobPricingSearchModels";
import { JobPricingReportConstants } from "../../constants/JobPricingReportConstants";
import { getLanguageCode } from "../../utilities/helper";

export const searchInitialState: JobPricingSearchState = {
  jobPricingPayloads: {
    allClientPaySubmissionKey: "0",
    clientPaySubmissionKeys: "0",
    countryCode: "ALL",
    geographyKey: "ALL",
    gradeId: "ALL",
    gradeSetID: "1",
    includeClientPaySubmissionKey: "NaN",
    jobFamilyName: "ALL",
    jobSubFamilyName: "ALL",
    jobKey: "ALL",
    jobsInOrg: "0",
    langKey: "ALL",
    language: getLanguageCode(),
    marketClass: "ALL",
    marketCompElement: "ALL",
    marketDefinitionKey: "0",
    marketEducation: "ALL",
    marketEmployeeCount: "ALL",
    marketIndustry: "ALL",
    marketJobEducation: "ALL",
    marketJobFamily: "ALL",
    marketJobSkill: "ALL",
    marketJobSubFamily: "ALL",
    marketJointCommittee: "ALL",
    marketOwnershipType: "ALL",
    marketPosition: [
      ...JobPricingReportConstants.DEFAULT_PERCENTILE_VALUES,
      JobPricingReportConstants.DEFAULT_AVERAGE_PERCENTILE_VALUES
    ].join(),
    marketRegion: "ALL",
    marketRevenueRange: "ALL",
    marketSubRegion: "ALL",
    marketYear: new Date().getFullYear().toString(),
    peerGroupKey: "ALL",
    totalPointsMax: "17540",
    totalPointsMin: "34",
    jobOrgCode: "ALL",
    searchCategory: "ALL",
    jobName: "ALL",
    jobDescription: "ALL",
    totalJobs: "0",
    gradeSpan: "ALL",
    searchTerm: ""
  } as JobPricingPayloads
};

export const reportSearchSlice = createSlice({
  name: "SJPR_Search_Slice",
  initialState: searchInitialState,
  reducers: {
    resetReportSearchState: () => searchInitialState,
    updateJobPricingPayloads: (state, action) => {
      state.jobPricingPayloads = {
        ...state.jobPricingPayloads,
        ...action.payload
      };
    }
  }
});

export const { resetReportSearchState, updateJobPricingPayloads } =
  reportSearchSlice.actions;

export default reportSearchSlice.reducer;
